import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { point } from '@turf/helpers';
import TurfBuffer from '@turf/buffer';
import { withLeaflet } from 'react-leaflet';
import 'leaflet-truesize';

import { is768Query } from '~/core/scripts/mediaquery-helper';

const radius = Math.sqrt(ARTICLE_CONFIG.area / Math.PI);
const centerPoint = point(ARTICLE_CONFIG.center.slice(0).reverse());
const bufferedPoint = TurfBuffer(centerPoint, radius, {
  units: 'kilometers',
  steps: 512
});

export default withLeaflet(props => {
  const [layer, setLayer] = useState(null);

  useEffect(() => {
    const layerClasses = classnames('leaflet-truesize', {
      'is-disabled': !is768Query()
    });
    const trueSizeLayer = new L.trueSize(bufferedPoint, {
      color: '#FFAA00',
      fillColor: '#FFAA00',
      fillOpacity: .4,
      weight: 1,
      opacity: 1,
      markerDiv:
        '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M31.922 16.618a.99.99 0 0 0-.216-.324l-4-4a1 1 0 0 0-1.414 1.414L28.586 16H18V5.414l2.292 2.292a1 1 0 0 0 1.414-1.414l-4-4-.01-.006a.978.978 0 0 0-.314-.208A.974.974 0 0 0 17 2h-.004a.999.999 0 0 0-.692.286l-.012.006-4 4a1 1 0 0 0 1.414 1.414L16 5.414V16H5.414l2.292-2.292a1 1 0 0 0-1.414-1.414l-4 4-.006.01a.978.978 0 0 0-.208.314A.974.974 0 0 0 2 17v.004a.999.999 0 0 0 .286.692l.006.012 4 4a1 1 0 0 0 1.414-1.414L5.414 18H16v10.586l-2.292-2.292a1 1 0 0 0-1.414 1.414l4 4a.99.99 0 0 0 .702.292H17c.13 0 .26-.026.382-.078a.99.99 0 0 0 .324-.216l4-4a1 1 0 0 0-1.414-1.414L18 28.586V18h10.586l-2.292 2.292a1 1 0 0 0 1.414 1.414l4-4a.99.99 0 0 0 .292-.702V17c0-.13-.026-.26-.078-.382z" fill="#fff"/></svg>',
      markerClass: 'drag-icon',
      iconAnchor: [16, 16],
      className: layerClasses
    }).addTo(props.leaflet.map);

    setLayer(trueSizeLayer);
  }, []);

  useEffect(() => {
    if (layer) {
      console.log(1);
      layer.setCenter(props.center);
    }
  }, [props.center]);

  return null;
});
